import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Slider = ({ onChange, sliderStartingView }) => {
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(sliderStartingView);

  const toggleSlider = () => {
    const newValue = !toggle;
    setToggle(newValue);
    onChange && onChange(newValue);
  };

  return (
    <div className="flex items-center gap-3">
      <span className={`text-sm font-semibold ${!toggle ? `text-[var(--feel-primary)]` : 'text-gray-500'}`}>{t('GENERAL.tableView')}</span>
      <label className="relative inline-flex items-center cursor-pointer">
        <input type="checkbox" checked={toggle} onChange={toggleSlider} className="sr-only peer" />
        <div
          className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--feel-primary)]/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--feel-primary)]`}
        ></div>
      </label>
      <span className={`text-sm font-semibold ${toggle ? `text-[var(--feel-primary)]` : 'text-gray-500'}`}>{t('GENERAL.cardsView')}</span>
    </div>
  );
};

export default Slider;
